import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AiAssistanceComponent } from './ai-assistance.component';

const routes: Routes = [
  { path: '', component: AiAssistanceComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiAssistanceRoutingModule {}